import actions from "@/core/store/modules/account/actions";
import getters from "@/core/store/modules/account/getters";
import mutations from "@/core/store/modules/account/mutations";


export default {
    state: {
        account: {},
        middlewares: {},
        permissions: {}
    },
    getters,
    mutations,
    actions
}